module.exports = __webpack_public_path__ + "img/order-complete.bc67297e.svg";